export default "__VITE_ASSET__DiwjlFC4__"